import { Table, TableContainer } from "@mui/material";
import { useContext, useEffect } from "react";
import useTable from "src/hooks/useTable";

import SkeletonTable from "../../UnknownRights/UnknownRightsTable/SkeletonTable";
import Context from "../context";
import ContextTable from "./contextTable";
import FilterHeader from "./FilterHeader/FilterHeader";
import useGetManageCompanies from "./service/useGetManageCompanies";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import TableNotFound from "./TableNotFound";
import TablePagination from "./TablePagination";

// ----------------------------------------------------------------------

export const TransactionsTable = () => {
	const { isLoading, getManageCompanies } = useGetManageCompanies();
	const { state } = useContext(Context);

	useEffect(() => {
		getManageCompanies(0, state.term, state.nullCifOnly);
	}, []);

	const onChangePage = (page: number, callback: () => void) => {
		getManageCompanies(page, state.term, state.nullCifOnly, callback);
	};
	console.log(state.data);
	const empty = state.data.length === 0;

	const control = useTable({
		defaultOrderBy: "createdAt",
		defaultRowsPerPage: 12,
		defaultDense: true
	});

	return (
		<ContextTable.Provider value={{ ...control }}>
			<FilterHeader />
			<TableContainer>
				{isLoading && <SkeletonTable />}
				{!isLoading && (
					<Table size='small'>
						<TableHeader />
						<TableBody data={state.data} />
						{empty && <TableNotFound />}
					</Table>
				)}
			</TableContainer>
			<TablePagination count={state.totalItems} onPageChange={onChangePage} />
		</ContextTable.Provider>
	);
};

export default TransactionsTable;
